import { NgIf } from '@angular/common';
import { Directive, OnDestroy, OnInit, inject } from '@angular/core';
import { Customer } from '@df/session/api/customer';
import { Subscription } from 'rxjs/internal/Subscription';
import { StoreCreditService } from './store-credit.service';

@Directive({
    selector: '[ifStoreCreditCanBeUsed]',
    standalone: true
})
export class IfStoreCreditCanBeUsedDirective extends NgIf implements OnInit, OnDestroy {
    protected subscriptions = new Subscription();
    protected storeCredit = inject(StoreCreditService);
    customer = inject(Customer);

    ngOnInit() {
        this.subscriptions.add(this.customer.model.obs.data.subscribe(() => this.update()));
        this.update();
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    protected update(): void {
        this.ngIf = this.storeCredit.canBeUsed;
    }
}
